module.exports = __webpack_public_path__ + "img/trash.99c128e5.svg";